/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
const root = (typeof window !== "undefined") ? window : globalThis;

root.animateScore = function(toScore) {
  const scores = $(".point-count");
  const start = parseInt($("#point-count").text());
  if (toScore !== 0) {
    const header = $(".header");
    const badge = header.find("#points-badge");
    badge.addClass("expand");
    badge.removeClass("collapse");
  }

  if (window.DISABLE_ANIMATIONS) {
    return scores.text(toScore);
  } else {
    const diff = toScore - start;
    const numberDelay = 800;
    if (diff > 0) {
      return $.each(new Array(diff + 1), i => window.setTimeout((() => scores.text(start + i)), (i * 50) + numberDelay));
    }
  }
};
